import React from "react";
import { Logo } from "@/components/Logo";

export const FullLoader = ({ text }: { text?: string }) => (
  <div data-testid="full-loader" className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background">
    <div className="animate-bounce">
      <Logo />
    </div>
    {text && <p className="text-muted-foreground text-sm">{text}</p>}
  </div>
);
